import { Option } from "~/types/component";

export const convertLabel = (options: Option[], value?: string | number) => {
  const result = options.find((option) => option.value === value);
  return result?.label;
};
